<template>
  <transition v-on:after-enter="afterEnter" name="fade">
    <div class="modal-mask" v-if="opened" @click.self="() => closeModal()">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click.self="() => closeModal()"
            >
              ×
            </button>
            <h3 class="modal-title">{{ header }}</h3>
          </div>
          <div class="modal-body">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
const emit = defineEmits(['close', 'after-enter']);

const props = defineProps({
  header: {
    type: String,
    required: false,
    default: ''
  },
  opened: {
    type: Boolean,
    required: true
  }
});

const closeModal = () => emit('close');

const afterEnter = () => emit('after-enter');
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.modal-content {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 60px);
}
.modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
}
</style>
